export const inputValidationDirective = ($parse, defaultErrorMessageResolver) => {
	'ngInject';
	
	defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
		errorMessages['inputValidation'] = 'Please enter a valid URL in the format of http(s)://www.google.com';
		errorMessages['email'] = 'Please enter a valid email address';
	});
	return {
		require: 'ngModel',
		restrict: 'A',
		link: (scope, element, attrs, ngModel) => {
			var pattern;
			if (attrs.key === "email") {
				pattern = /([\w-\.]+)@((?:[\w-]+\.)+)([a-zA-Z]{2,4})/
				ngModel.$validators.email = (value) => {
					return ngModel.$isEmpty(value) || pattern.test(value)
				};
			} else if(attrs.type === "url") {
				pattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
				ngModel.$validators.inputValidation = (value) => {
					return ngModel.$isEmpty(value) || pattern.test(value)
				};
			} else if(attrs.type === "text") {
				ngModel.$parsers.push((text) => {
					var modifiedInput = text;
					
					if(modifiedInput)
						modifiedInput = modifiedInput.replace(/[^0-9]/g, '');

					if (modifiedInput != text) {
						ngModel.$setViewValue(modifiedInput);
						ngModel.$render();
					}
					return modifiedInput;
				});
				ngModel.$formatters.push((text) => {
					var modifiedInput = text;
					
					if(modifiedInput)
						modifiedInput = modifiedInput.replace(/[^0-9]/g, '');

					if (modifiedInput != text) {
						ngModel.$setViewValue(modifiedInput);
						ngModel.$render();
					}
					return modifiedInput;
				});	
			}		
		}
	};
};


// WEBPACK FOOTER //
// ./src/app/common/components/input-validation/input-validation.directive.js